/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * the data of the multi set (generated from (datachange_multi_metadata_field & datachange_multi_data)
 */
export interface DatachangeMultiDataField { 
    /**
     * the name of the field (datachange_multi_metadata_field -> sub_path  -!-> ALSO -!-> datachange_multi_data -> data_old/data_new -> the key)
     */
    fieldName: string;
    /**
     * the value of the field (datachange_multi_data -> data_old/data_new -> the value)
     */
    value: string;
    /**
     * the type of the field (datachange_multi_metadata_field -> data_type)
     */
    fieldType?: string;
    /**
     * the order of the field (datachange_multi_metadata_field -> column_order)
     */
    sortOrder?: number;
}

